import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I&apos;m <span className="purple">Henry H. Chen</span> from{" "}
            <span className="purple">Los Angeles, CA.</span>
            <br />
            I graduated from UC Berkeley.
            <br />
            <br />
            Outside of work, a few things I enjoy:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing badminton and pickleball
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading up on new technologies
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling and exploring new places
            </li>
            <li className="about-activity">
              <ImPointRight /> Incorporating smart home devices and woodworking
            </li>
          </ul>
        
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
